import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=c3e1f41a&scoped=true"
import script from "./PanelLayout.vue?vue&type=script&lang=js"
export * from "./PanelLayout.vue?vue&type=script&lang=js"
import style0 from "./PanelLayout.vue?vue&type=style&index=0&id=c3e1f41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e1f41a",
  null
  
)

export default component.exports